import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-final-form";
import { Modal } from "antd";

import {
  ContentLoader,
  FormField,
  FormFieldType,
  Notification,
  NOTIFICATION_TYPES
} from "@components";
import { i18, required, trb } from "@utilities";
import { RenderRiskList } from "../RenderRiskList";
import { ApplicationsActions, selectCurrentApplication } from "@redux";

const RISK_LIST = [
  {
    label: "Low",
    value: "Low"
  },
  {
    label: "Medium",
    value: "Medium"
  },
  {
    label: "High",
    value: "High"
  },
  {
    label: "Unacceptable",
    value: "Unacceptable"
  }
];

export const ApproveRisksModal = ({ onClose }) => {
  const dispatch = useDispatch();
  const application = useSelector(selectCurrentApplication);
  const [isRiskPdfUploading, setIsRiskPdfUploading] = useState(false);
  const [risksApproved, setRisksApproved] = useState(true);

  const overideRiskDefaultValue = application?.risks?.finalRisk || "Select Final Risk";

  const startRiskApproval = async values => {
    setIsRiskPdfUploading(true);
    try {
      // if successful risk loader is removed after pdf is finished formating
      await dispatch(ApplicationsActions.approveRisk(application.id, values));
      setRisksApproved(true);
    } catch (e) {
      setIsRiskPdfUploading(false);
    }
  };

  const finishRiskPdfUpload = () => {
    setIsRiskPdfUploading(false);
    Notification({
      type: NOTIFICATION_TYPES.SUCCESS,
      message: i18.NotificationTitles.SuccessOperation
    });
    onClose();
  };

  return (
    <>
      <Form
        onSubmit={startRiskApproval}
        initialValues={{ overrideRisk: overideRiskDefaultValue }}
        render={({ handleSubmit }) => {
          return (
            <Modal
              visible
              onOk={handleSubmit}
              onCancel={onClose}
              okText={trb(i18.Buttons.Ok)}
              cancelText={trb(i18.Buttons.Cancel)}
              cancelButtonProps={{
                loading: isRiskPdfUploading
              }}
              okButtonProps={{
                loading: isRiskPdfUploading
              }}
            >
              {isRiskPdfUploading ? (
                <ContentLoader />
              ) : (
                <>
                  <form id="approveDocument" className="my-4" onSubmit={handleSubmit}>
                    <FormField
                      name="comment"
                      component={FormFieldType.input}
                      title="Comment"
                      validate={required}
                      size="large"
                    />
                    <FormField
                      name="overrideRisk"
                      validate={required}
                      component={FormFieldType.select}
                      options={RISK_LIST}
                      optionsLabel="label"
                      optionsValue="value"
                    />
                  </form>
                </>
              )}
            </Modal>
          );
        }}
      />
      {application?.risks && isRiskPdfUploading && risksApproved && (
        <RenderRiskList
          risksEntity={application.risks}
          finishUpload={finishRiskPdfUpload}
          appId={application.id}
          onUnMount={() => setRisksApproved(false)}
          generalAppInfo={{
            clientName: application?.clientName,
            clientCode: application?.clientCode
          }}
        />
      )}
    </>
  );
};
